"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEGATIVE_VARIANT = exports.MIN_PERCENT_VALUE = exports.MAX_PERCENT_VALUE = exports.INACTIVE_VARIANT = void 0;
const MAX_PERCENT_VALUE = exports.MAX_PERCENT_VALUE = 100;
const MIN_PERCENT_VALUE = exports.MIN_PERCENT_VALUE = 0;
const INACTIVE_VARIANT = exports.INACTIVE_VARIANT = 'inactive';
const NEGATIVE_VARIANT = exports.NEGATIVE_VARIANT = 'negative';